import { handleIsMobile } from '@/lib/utils';
import { useEffect, useState } from 'react';

export const useIsMobile = () => {
    const [isMobile, setSetIsMobile] = useState(handleIsMobile());

    useEffect(() => {
        const handleResize = () => {
            setSetIsMobile(handleIsMobile());
        };

        window.addEventListener('resize', handleResize);

        // Cleanup при размонтировании компонента
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile;
};
